// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import isApiError from "@insite/client-framework/Common/isApiError";
import { get, ServiceResult } from "@insite/client-framework/Services/ApiService";

const csrServiceUrl = "/api/ces/profileInformation/csr";

export interface CsrDataModel {
    [key: string]: { name?: string; phone?: string; email?: string };
}

export async function getCsrData(): Promise<ServiceResult<CsrDataModel>> {
    try {
        const csrData = await get<CsrDataModel>(csrServiceUrl);
        return { result: { ...csrData }, successful: true };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
